var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StringValueRow',{staticClass:"clickable",class:_vm.Strings.isEven(_vm.index) ? 'rowEven ' : ' rowOdd ',attrs:{"label":_vm.companyName(),"value":_vm.identifierValue(),"labelWidth":"rc-box-col-13","valueWidth":"rc-box-col-2","stylingValue":"rc-text-right"},on:{"click":function($event){return _vm.showCompanyDetails()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }